import { render, staticRenderFns } from "./channel-action.html?vue&type=template&id=3ec340dc&scoped=true&"
import script from "./channel-action.js?vue&type=script&lang=js&"
export * from "./channel-action.js?vue&type=script&lang=js&"
import style0 from "./channel-action.scss?vue&type=style&index=0&id=3ec340dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec340dc",
  null
  
)

export default component.exports